export const Shadows = {
  none: 'none',
  xs: '0 2px 4px 0 rgba(36, 35, 41, 0.08)',
  sm: '0 4px 8px 0 rgba(36, 35, 41, 0.08)',
  md: '0 8px 24px 0 rgba(36, 35, 41, 0.08)',
  lg: '0 16px 32px 0 rgba(36, 35, 41, 0.08)',
  xl: '0 24px 48px 0 rgba(36, 35, 41, 0.08)',
} as const;

export type ShadowsTokenType = keyof typeof Shadows;
